/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line no-shadow
export enum Gender {
  M = 1,
  F = 2
}
